/* eslint-disable
    func-names,
    guard-for-in,
    no-restricted-syntax,
    no-shadow,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const deps = ['Model'];

const factory = function (Model) {
  let Currency;
  return (Currency = (function () {
    Currency = class Currency extends Model {
      static initClass() {
        this.prototype.$resource = 'currency';

        this.prototype.id = null;
        this.prototype.code = null;
        this.prototype.name = null;
      }

      $$filterData(data) {
        const transformedData = {};

        const isNum = num => /^\d+$/.test(num);

        for (const key in data) {
          const val = data[key];
          transformedData[key] = isNum(val) ? Number(val) : val;
        }

        return super.$$filterData(transformedData);
      }
    };
    Currency.initClass();
    return Currency;
  })());
};

factory.$inject = deps;

const moduleDeps = [require('data/util').name];

module.exports = angular
  .module('bench.data.model.currency', moduleDeps)
  .factory('Currency', factory);
